module.exports = require('./helpers/bundle-url').getBundleURL('bKm04') + "logo-dark.ba5147f0.svg";